import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const reclaimWinRateOverTimeRowSchema = z.object({
  weekStart: z.coerce.date(),
  won: z.number().int(),
  lost: z.number().int(),
  wonExcludingProtected: z.number().int(),
  lostExcludingProtected: z.number().int(),
});

export interface ReclaimWinRateOverTimeRow
  extends z.infer<typeof reclaimWinRateOverTimeRowSchema> {}

export const getReclaimWinRateOverTime = unaryRpc({
  name: "getReclaimWinRateOverTime" as const,
  input: z.object({ weeksBack: z.number().int().min(1).max(104).optional() }),
  output: z.object({
    rows: z.array(reclaimWinRateOverTimeRowSchema),
    weeksBack: z.number().int(),
  }),
});
